angular.module('TetherApp').factory('formService', ['formDataService', function (formDataService) {

    return {
        getTemplate: formDataService.getTemplate,
        getInput: formDataService.getInput,
        getOldInput: formDataService.getOldInput,
        getErrors: formDataService.getErrors,
        getPopulate: formDataService.getPopulate
    };

}]);
